import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';

class NotFound extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="error404 page">
                <Header />
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <h1>4.0.4.</h1>
                            <h2>
                                Oops. This page doesn’t seem to exist
                                {this.props.project && (
                                    <span style={{ display: 'block' }}>
                                        Project: {this.props.project}
                                    </span>
                                )}
                                <br />
                                go back to <a href="/">home</a>
                            </h2>
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        );
    }
}

export default withRouter(NotFound);



// WEBPACK FOOTER //
// ./src/containers/NotFound.jsx